<template>
  <div class="container contact-main-container" v-bind:style="'direction:' + direction">
    <h3>{{source.title}}</h3>
    <div class="contact-field-container">
      <div v-bind:class="'div-contact-info ' + direction_class">
        <ul>
          <li>{{source.work_hours}}</li>
          <li>{{source.work_hours_every_day}}</li>
          <li>{{source.work_hours_friday_day}}</li>
          <li>{{source.holiday}}</li>
          <li>{{source.pre_entry}}</li>
          <li>{{source.email + ': ' + this.$store.getters.SITE_DATA.config.data.contact_email}}</li>
          <li>{{source.address +': '+ source.location}}</li>
        </ul>
      </div>
      <div class="form-group row">
        <div v-bind:class="'col-md-12 ' + direction_class">
          <label for="conatact_name">{{source.name}}</label>
          <input
            type="text"
            class="form-control"
            id="conatact_name"
            aria-describedby="contactNameHelp"
            placeholder="Name"
            v-model="contact.name"
          />
        </div>
      </div>
      <div class="form-group row">
        <div v-bind:class="'col-md-12 ' + direction_class">
          <label for="conatact_email">{{source.email}}</label>
          <input
            type="text"
            class="form-control"
            id="conatact_email"
            aria-describedby="contactEmailHelp"
            placeholder="Email"
            v-model="contact.email"
          />
        </div>
      </div>
      <div class="form-group row">
        <div v-bind:class="'col-md-12 ' + direction_class">
          <label for="conatact_tel">{{source.telephone}}</label>
          <input
            type="text"
            class="form-control"
            id="conatact_tel"
            aria-describedby="contactTelHelp"
            placeholder="Telephone"
            v-model="contact.telephone"
          />
        </div>
      </div>
      <div class="form-group row">
        <div v-bind:class="'col-md-12 ' + direction_class">
          <label for="conatact_msg">{{source.message}}</label>
          <textarea
            class="form-control"
            id="conatact_msg"
            style="resize: none;"
            rows="5"
            v-model="contact.message"
          ></textarea>
        </div>
      </div>
      <button type="bottom" class="btn btn-primary" @click="(e) => sendContact(e)">{{source.button}}</button>
    </div>
    <div id="myMap"></div>
  </div>
</template>

<script>
import { getDataFromServer } from "../utils/DataProvider";
export default {
  data() {
    return {
      source: {},
      contact: { name: "", email: "", message: "", telephone: "" },
      direction: "",
      direction_class: "",
      map: ""
    };
  },
  methods: {
    sendContact(e) {
      this.contact.emailToSend = this.$store.getters.SITE_DATA.config.data.contact_email;
      getDataFromServer("contact_us", this.contact)
        .then(obj => {
          if (obj.data.success === true) {
            console.log("contact result", obj.data);
          } else {
            this.flash("get contact error: " + obj.data.text, "error", {
              timeout: 5000
            });
          }
        })
        .catch(err => {
          this.flash("get contact error: " + obj.data.text, "error", {
            timeout: 5000
          });
        });
    }
  },
  mounted() {
    // init map
    console.log("map: ", google.maps);
    var CenterGirudo = new google.maps.LatLng(32.09415, 34.81813);

    this.map = new google.maps.Map(document.getElementById("myMap"), {
      center: { lat: 32.0938545, lng: 34.8159948 },
      scrollwheel: false,
      zoom: 17
    });
    var marker = new google.maps.Marker({
      position: CenterGirudo,
      label: "GIRUDO",
      opacity: 0.8
    });
    marker.setTitle("Ramat Gan, Abba Hillel 140");
    marker.setMap(this.map);
    // map
  },
  created() {
    this.source = this.$store.getters.SOURCE_JSON.contact
    this.source.location = this.$store.getters.SOURCE_JSON.general.location
    this.direction =
      this.$store.getters.CURRENT_LANGUAGE === "he_IL" ? "rtl" : "ltr";
    this.direction_class =
      this.$store.getters.CURRENT_LANGUAGE === "he_IL"
        ? "label-right"
        : "label-left";

    console.log("contact source: ", this.$store.getters.SOURCE_JSON.contact);
    console.log("contact source 1: ", this.source);
  }
};
</script>

<style scoped>
.contact-main-container {
  margin-top: 200px;
  margin-bottom: 50px;
  text-align: center;
  display: flex;
  flex-direction: column;
}

.contact-field-container {
  align-self: center;
  width: 600px;
}

ul {
  list-style: none;
  margin: 0 0 40px 5px;
  padding: 0;
}

.div-contact-info {
  color: #000;
  text-align: left;
}
#myMap {
  height: 300px;
  width: 100%;
  margin: 1rem 0;
}

@media screen and (max-width: 767px){
    .contact-field-container{
      width: unset;       
    }
    .contact-main-container {
      margin-top: 90px;
    }
}
</style>
